import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk for fetching course details
export const fetchCourses = createAsyncThunk(
  'userCourseDetail/fetchCourses',
  async ({ apiCaller, status, uniqueCourseKeyInEmployeeCourses }, { rejectWithValue }) => {
    try {
      const response = await apiCaller.post('/user/courseDetails', {
        status,
        uniqueCourseKeyInEmployeeCourses,
      });
      return response.data?.data?.coursesData;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const userCourseDetail = createSlice({
  name: 'userCourseDetail',
  initialState: {
    coursesData: [],
    isSuccess: false,
    isloading: false,
    message: '',
  },
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCourses.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCourses.fulfilled, (state, action) => {
        state.coursesData = action.payload;
        state.loading = false;
      })
      .addCase(fetchCourses.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default userCourseDetail;
